import React from "react";

const Stats = ({ stats }) => {
  return (
    <div className="stats-container">
      {stats.map((stat, index) => (
        <div key={index} className="stat-item">
          <h3>{stat.amount}</h3>
          <p>{stat.description}</p>
        </div>
      ))}
    </div>
  );
};

export default Stats;
